import { post } from '../utility';

export const search = ({ afterDate, beforeDate, callback }) => {
	post({
		method: 'fuelContractFulfillment.search',
		params: { afterDate, beforeDate },
		callback,
	});
};
